import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';
import { isDevMode } from '~/utils/mainHelpers/isDevMode';

class TemplateService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiDataURL,
      headers,
    });
    addInterceptors(this.axios);

    this.templateAxios = axios.create({
      baseURL: process.env.API_TEMPLATE_URL,
      headers,
    });

    this.templateAxiosProd = axios.create({
      baseURL: 'https://template.api.design-ac.net',
      headers,
    });
    addInterceptors(this.templateAxios);

    // this.tempAxios = axios.create({
    //   baseURL: 'https://dutpfz3vj0.execute-api.us-west-2.amazonaws.com/dev/',
    //   headers,
    // });
    // addInterceptors(this.tempAxios);

    this.feedbackAxios = axios.create({
      baseURL: 'https://www.design-ac.net',
      headers,
    });
  }

  loadTemplateDetail = ({ templateID, role }) => {
    const request = {
      method: 'GET',
      url: '/templates/detail',
      params: {
        id: templateID,
        role,
      },
    };
    return this.templateAxios(request);
  };

  listTemplates = ({
    categoryIDs,
    categoryID,
    page,
    status,
    excludeCategoryId,
    max_results,
    type,
    categorySlug,
    role,
    lang,
    isNewyearSite,
    isRandom,
  }) => {
    const request = {
      method: 'GET',
      url: '/templates',
      params: {
        categoryIDs: categoryIDs && categoryIDs.join(','),
        category_id: categoryID,
        cat_slug: categorySlug,
        status,
        page,
        max_results: max_results || 20,
        excludeCategoryId,
        type,
        role,
        lang,
        isNewyearSite,
        is_random: isRandom,
      },
    };
    return this.axios(request);
  };

  listTemplatesForHomePage = ({ max_results, role, lang }) => {
    const request = {
      method: 'GET',
      url: '/templates/home',
      params: {
        max_results: max_results || 20,
        role,
        lang: lang || 'ja',
      },
    };
    return this.templateAxios(request);
  };

  listRepresentativeTemplatesForHomePage = ({ role, lang }) => {
    const request = {
      method: 'GET',
      url: '/templates/representative',
      params: {
        max_results: 1,
        role,
        lang: lang || 'ja',
      },
    };
    return this.templateAxios(request);
  };

  listNewTemplates = ({ page, max_results, role, lang }) => {
    const request = {
      method: 'GET',
      url: '/templates/new',
      params: {
        page,
        max_results: max_results || 20,
        role,
        lang,
      },
    };
    return this.templateAxios(request);
  };

  listPopularTemplates = ({ page, max_results, role, lang }) => {
    const request = {
      method: 'GET',
      url: '/templates/popular',
      params: {
        page,
        max_results: max_results || 20,
        role,
        lang,
      },
    };
    return this.templateAxios(request);
  };

  insertDbOfTemplate = ({
    title,
    description,
    dataURL,
    thumbnailURL,
    width,
    height,
    fontIDs,
    creatorRole,
    categoryId,
    numberPages,
  }) => {
    const request = {
      method: 'POST',
      url: '/templates',
      data: {
        title,
        description,
        data_url: dataURL,
        thumbnail_url: thumbnailURL,
        width,
        height,
        fontIDs,
        creatorRole,
        category_id: categoryId,
        num_pages: numberPages,
      },
    };
    return this.axios(request);
  };

  getUrlOfItem = (id) => {
    const request = {
      method: 'POST',
      url: '/templates/download',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  downloadTemplateImage = (key) => {
    const request = {
      method: 'POST',
      url: '/downloadImage',
      data: { key },
    };
    return this.axios(request);
  };

  downloadAnyImage = (url) => {
    const request = {
      method: 'POST',
      url: '/downloadImage',
      data: { url },
    };
    return this.axios(request);
  };

  updateTemplate = ({
    id,
    title,
    description,
    dataURL,
    thumbnailURL,
    width,
    height,
    fontIDs,
    validationStatus,
    categoryId,
    workareaUnit,
    numberPages,
  }) => {
    const request = {
      method: 'PUT',
      url: '/templates',
      data: {
        id,
        title,
        description,
        data_url: dataURL,
        thumbnail_url: thumbnailURL,
        width,
        height,
        fontIDs,
        validation_status: validationStatus,
        category_id: categoryId,
        workarea_unit: workareaUnit,
        num_pages: numberPages,
      },
    };
    return this.axios(request);
  };

  deleteTemplate = (id) => {
    const request = {
      method: 'DELETE',
      url: '/templates',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  linkWithDesignAC = ({ id, dataID }) => {
    const request = {
      method: 'POST',
      url: '/templates/link-designac',
      data: {
        id,
        data_id: dataID,
      },
    };
    return this.axios(request);
  };

  deleteTemplate = (id) => {
    const request = {
      method: 'DELETE',
      url: '/templates',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  feedbackCollab = async (message, gRecaptcha) => {
    const request = {
      method: 'POST',
      url: '/feedback',
      data: {
        message,
        'g-recaptcha-response': gRecaptcha,
      },
    };
    return this.feedbackAxios(request);
  };

  searchTemplates = async ({ keyword, page, max_results, role, lang }) => {
    const request = {
      method: 'GET',
      url: '/templates/search',
      params: {
        keyword,
        role,
        lang: lang || 'ja',
        max_results,
        page,
      },
    };
    return this.templateAxios(request);
  };

  templateByNewyearID = ({ newyearID, role }) => {
    const request = {
      method: 'GET',
      url: '/template/newyear',
      params: {
        newyear_id: newyearID,
        role,
      },
    };
    return this.templateAxios(request);
  };

  incrementCountUse = ({ templateID, role, level, type }) => {
    const request = {
      method: 'POST',
      url: '/template/increment',
      data: {
        id: templateID,
        role,
        level,
        type,
      },
    };
    return this.templateAxios(request);
  };

  addTemplateForCustomization(templateID) {
    const request = {
      method: 'POST',
      url: '/template/add-for-customization',
      data: {
        templateID,
      },
    };
    return this.templateAxios(request);
  }
  invalidThumbnail = ({ paths, role }) => {
    const request = {
      method: 'POST',
      url: '/template/invalidate-thumbnail',
      data: {
        paths,
        role,
      },
    };
    if (isDevMode()) {
      return this.templateAxiosProd(request);
    } else {
      return this.templateAxios(request);
    }
  };
}

export default new TemplateService();
